export const environment = {
  production: false,
  apiBaseUrl: 'https://voucherapi.sdaemon.com/api/'
 // apiBaseUrl: 'https://localhost:65451/api/'
 // apiBaseUrl: 'https://voucherapi.kisna.com/api/'

};
